<div class="mb-4 flex h-16 md:mb-6">
  <div
    class="mr-2 flex h-16 w-16 items-center justify-center rounded-full border-4 border-solid bg-center bg-no-repeat"
    [ngClass]="'badge-' + accomplishment.badge.color"
    [style.background-image]="'url(' + accomplishment.badge.src + ')'"
  ></div>

  <div class="flex flex-col justify-center">
    @if (accomplishment.titleTranslationKey) {
      <p class="m-0 font-bold">{{ accomplishment.titleTranslationKey | transloco }}</p>
    }
    @if (accomplishment.customTitle; as t) {
      <p class="m-0 font-bold">
        <span>{{ t.numberOfYears }}x </span>
        @if (t.awardTypeTranslationKey) {
          <span>{{ t.awardTypeTranslationKey | transloco }} </span>
        }
        @if (t.rankingTranslationKey) {
          <span>{{ t.rankingTranslationKey | transloco: { rankedOutOf: t.rankedOutOf } }}</span>
        }
      </p>
    }
    @if (accomplishment.subtitle) {
      <p class="m-0 font-bold">{{ accomplishment.subtitle }}</p>
    }
    @if (accomplishment.descriptionTranslationKey && !accomplishment.customTitle) {
      <p class="m-0 text-steel-60">
        {{ accomplishment.descriptionTranslationKey | transloco }}
      </p>
    }
    @if (accomplishment.descriptionTranslationKey && accomplishment.customTitle) {
      <p class="m-0 text-steel-60">
        {{ accomplishment.descriptionTranslationKey }}
      </p>
    }
  </div>
</div>
